export const MAX_LENGTH_EMAIL = 200;
export const MAX_LENGTH_INPUT = 150;
export const MAX_LENGTH_APPLICATION_NOTE = 10000;
export const MAX_LENGTH_CONTACT_US_MESSAGE = 10000;
export const MIN_LENGTH_PASSWORD = 6;
export const MAX_LENGTH_ABOUT_ME = 10000;
export const SEARCH_PAGE_SIZE = 10;
